<template>
  <div>
    <div class="header">
      <div class="left">
        <el-row>
          <h3 style="margin: 0  0 20px 0; color: green">自定义角色管理</h3>
        </el-row>

        <el-row class="left-content">
          <el-input prefix-icon="el-icon-search" placeholder="请输入角色姓名" size="small" clearable
                    style="width: 400px; cursor: pointer" v-model="searchContent"/>

          <el-button type="info" plain size="mini" style="margin-left: 5px" @click="search">搜索</el-button>
        </el-row>
      </div>

      <div class="right">
        <el-button type="primary" size="mini" @click="addRole" :disabled="!hasCommitPermission">添加角色</el-button>
      </div>
    </div>
    <div class="content">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="name" label="角色名称" width="140px"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160px">
          <template v-slot="scope">{{ scope.row['createTime'] | timeFilter }}</template>
        </el-table-column>
        <el-table-column label="权限列表">
          <template slot-scope="scope">
            <el-tag v-for="item in scope.row['showPermissions']" :key="item.key" type="success"
                    style="margin-right: 5px; margin-bottom: 5px">
              {{ item.label }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="150px">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="tableUpdate(scope.row)" :disabled="!hasCommitPermission">修改</el-button>
            <el-button type="danger" size="mini" @click="tableDelete(scope.row)" :disabled="!hasCommitPermission">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination layout="prev, pager, next"
                       :total="pagiTotal"
                       :page-size="pagiPageSize"
                       :pager-count="5"
                       :current-page.sync="index"
                       @current-change="handlePagination">
        </el-pagination>
      </div>
    </div>

    <el-drawer :visible.sync="roleDrawerShow" size="600px">
      <el-form :model="drawerForm" ref="form" class="edit-form">
        <div class="main-content">


          <el-form-item label="账号名称:" prop="name">
            <el-input v-model="drawerForm.name" :disabled="!drawerForAdd"></el-input>
          </el-form-item>

          <el-form-item label="已选权限">
            <el-select v-model="permissionSelectedShow" multiple disabled>
              <el-option v-for="item in permissionSelectedAll" :key="item.key" :label="item.label" :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="权限设置">
            <el-tree
                title="权限设置"
                :data="permissionTree"
                show-checkbox
                node-key="key"
                default-expand-all
                ref="permissionTree"
                highlight-current
                @check-change="permissionCheckChange"
                :default-checked-keys="permissionSelectedShow"
                :props="permissionProps">
            </el-tree>
          </el-form-item>
        </div>

        <div class="footer-content">
          <el-form-item>
            <el-button size="mini" type="primary" @click="onPermissionSubmimt" :disabled="!hasCommitPermission">确认</el-button>
            <el-button size="mini" @click="roleDrawerShow = false">取消</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-drawer>

  </div>
</template>

<script>

import {addRole, deleteRole, getAllRoleList, updateRole} from "@/api/role-api";
import {mixin_table} from "@/utils/mixin";
import {getAccountPermissionSetting} from "@/api/account-api";

export default {
  name: "RoleManagerPage",
  mixins: [mixin_table],

  data() {
    return {
      roleDrawerShow: false,
      drawerForAdd: true,
      drawerForm: {
        name: "",
        showPermissions: [],
      },

      searchContent: null,

      permissionsAll: [], //原始数据
      permissionProps: {
        children: 'items',
        label: 'label'
      },

      permissionSelectedAll: [],
      permissionSelectedShow: [],

      permissionTree: [
        {
          "key": "VISITOR_FORM",
          "type": "",
          "label": "访客表单",
          "items": [
            {"key": "VISITOR_FORM_SELECT", "label": "查看访客表单"},
            {"key": "VISITOR_FORM_MODIFY", "label": "修改访客表单"}
          ]
        }, {
          "key": "VISITOR_FLOW",
          "type": "",
          "label": "访客流程",
          "items": [
            {"key": "VISITOR_FLOW_SELECT", "label": "查看访客流程"},
            {"key": "VISITOR_FLOW_MODIFY", "label": "修改访客流程"}
          ]
        }, {
          "key": "VISITOR_SYSTEM_SETTING",
          "type": "",
          "label": "系统设置",
          "items": [
            {"key": "SYSTEM_SETTING_SELECT", "label": "查看系统设置"},
            {"key": "SYSTEM_SETTING_MODIFY", "label": "修改系统设置"}
          ]
        }, {
          "key": "GUARD_HELPER",
          "type": "",
          "label": "门岗助手",
          "items": [
            {"key": "GUARD_HELPER_SELECT", "label": "查看门岗助手"},
            {"key": "GUARD_HELPER_MODIFY", "label": "操作门岗助手"}
          ]
        }, {
          "key": "HARDWARE_MANAGE",
          "type": "",
          "label": "硬件管理",
          "items": [
            {"key": "AREA_MANAGE_SELECT", "label": "查看区域信息"},
            {"key": "AREA_MANAGE_MODIFY", "label": "修改区域信息"},
            {"key": "DEVICE_MANAGE_SELECT", "label": "查看访客设备"},
            {"key": "DEVICE_MANAGE_MODIFY", "label": "修改访客设备"}]
        }, {
          "key": "EMPLOYEE_MANAGE",
          "type": "",
          "label": "员工管理",
          "items": [
            {"key": "EMPLOYEE_MANAGE_SELECT", "label": "查看员工信息"},
            {"key": "EMPLOYEE_MANAGE_MODIFY", "label": "修好员工信息"}
          ]
        }, {
          "key": "VISITOR_MANAGE",
          "type": "",
          "label": "访客管理",
          "items": [
            {"key": "VISITOR_MANAGE_SELECT", "label": "查看访客信息"},
            {"key": "VISITOR_MANAGE_MODIFY", "label": "修改访客信息"}
          ]
        }, {
          "key": "ROLE_MANAGE",
          "type": "",
          "label": "角色管理",
          "items": [
            {"key": "ROLE_MANAGE_SELECT", "label": "查看角色信息"},
            {"key": "ROLE_MANAGE_MODIFY", "label": "修改角色信息"}
          ]
        }
        , {
          "key": "LOG_MANAGE",
          "type": "",
          "label": "日志查看",
          "items": [
            {"key": "LOG_MANAGE_SELECT", "label": "日志查看"}
          ]
        }, {
          "key": "HOME_SCREEN",
          "type": "",
          "label": "首页大屏",
          "items": [{"key": "HOME_SCREEN_SELECT", "label": "首页大屏"}]
        }],

      tableSelectRow: null,

    }
  },

  mounted() {

    getAccountPermissionSetting().then(({data}) => {
      if (data.code === 200) {
        this.permissionsAll = data.data
        data.data.forEach((item) => {

          // 部门权限
          if (item.target === "VISITOR_TOP_DEPARTMENT") {
            // this.permissionTree.unshift({
            //   key: item.target + "|" + item.departmentId,
            //   type: "top",
            //   label: item.departmentName,
            //   items: [
            //     {key: "APPLY_RECORD_SELECT" + "|" + item.departmentId + "|top", label: `申请记录(${item.departmentName})`,},
            //     {key: "ARRIVE_RECORD_SELECT" + "|" + item.departmentId + "|top", label: `到访记录(${item.departmentName})`,}
            //   ]
            // })
          }


          // 区域权限
          if (item.target === "VISITOR_TOP_AREA") {
            this.permissionTree.unshift({
              key: item.target + "|" + item.areaId,
              type: "area",
              label: item.areaName,
              items: [
                {key: "APPLY_RECORD_SELECT" + "|" + item.areaId + "|area", label: `申请记录(${item.areaName})`,},
                {key: "ARRIVE_RECORD_SELECT" + "|" + item.areaId + "|area", label: `到访记录(${item.areaName})`,}
              ]
            })
          }


        })
        this.setupPageData()
      } else {
        this.showServerErrMsg(data.code);
      }

    }).catch((error) => {
      console.log("error =>", error)
    })
  },

  methods: {
    setupPageData() {
      getAllRoleList().then(({data}) => {
        if (data.code === 200) {
          data.data.forEach((item) => {
            item.showPermissions = []
            item.permissions.forEach((leve1) => {
              leve1.items.forEach((leve2) => {

                if (leve2.state === "VALID") {
                  let key = leve2.type
                  if (leve1.departmentId) {
                    key = leve2.type + "|" + leve1.departmentId + "|top"
                  }
                  if (leve1.areaId) {
                    key = leve2.type + "|" + leve1.areaId + "|area"
                  }
                  let label = this.getPermissionLabelByKey(key)
                  item.showPermissions.push({key: key, label: label})
                }
              })
            })
          })
          this.tableAllData = data.data
          this.tableShowData = this.tableAllData

          this.initPaginationTable()
        } else {
          this.$message.error(data.message)
        }
      }).catch(() => {
        this.$message.error(this.NETWORK_ERROR_MSG)
      })
    },
    getPermissionLabelByKey(key) {
      let label = ""
      this.permissionTree.forEach((item) => {
        if (item.key === key) {
          label = item.label
        } else {
          item.items.forEach((item2) => {
            if (item2.key === key) {
              label = item2.label
            }
          })
        }
      })

      return label
    },
    search() {
      if (this.searchContent === null || this.searchContent === "") {
        this.tableShowData = this.tableAllData
        this.initPaginationTable()
        return
      }

      let searchList = []

      this.tableAllData.forEach((item) => {
        if (item.name.indexOf(this.searchContent) !== -1) {
          searchList.push(item)
        }
      })

      this.tableShowData = searchList
      this.initPaginationTable()
    },

    addRole() {

      this.roleDrawerShow = true
      this.drawerForAdd = true
      this.drawerForm.name = ""
      this.drawerForm.showPermissions = []
      this.permissionSelectedAll = []
      this.permissionSelectedShow = []

      if (this.$refs.permissionTree && this.$refs.permissionTree.getCheckedKeys()) {
        this.$refs.permissionTree.getCheckedKeys().forEach((item) => {
          this.$refs.permissionTree.setChecked(item, false)
        })
      }

    },

    tableUpdate(row) {

      console.log("tableUpdate row =>", row)
      this.tableSelectRow = row
      let rowData = JSON.parse(JSON.stringify(row))
      this.roleDrawerShow = true
      this.drawerForAdd = false
      this.drawerForm.name = rowData.name

      this.drawerForm.showPermissions = rowData.showPermissions
      this.permissionSelectedAll = []
      this.permissionSelectedShow = []

      if (rowData.permissions) {
        this.permissionSelectedAll = rowData.showPermissions
        this.permissionSelectedShow = this.permissionSelectedAll.map(item => item.key)
      }

      if (this.$refs.permissionTree && this.$refs.permissionTree.getCheckedKeys()) {
        this.$refs.permissionTree.getCheckedKeys().forEach((item) => {
          this.$refs.permissionTree.setChecked(item, false)
        })
        this.permissionSelectedShow.forEach((item) => {
          this.$refs.permissionTree.setChecked(item, true)
        })
      }
    },

    tableDelete(row) {
      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        deleteRole(row.id).then(({data}) => {
          if (data.code === 200) {
            this.$message.success(data.message)
            this.setupPageData()
          } else {
            this.$message.error(data.message)
          }
        }).catch(() => {
          this.$message.error(this.NETWORK_ERROR_MSG)
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    handlePagination() {
      this.tableShowData = this.tableData.slice((this.index - 1) * this.pagiPageSize, this.index * this.pagiPageSize)
    },

    permissionCheckChange(data, checked) {
      // 父节点不处理
      if (data.items) {
        return
      }

      if (checked) {
        if (!this.permissionSelectedShow.includes(data.key)) {
          this.permissionSelectedShow.push(data.key)
          this.permissionSelectedAll.push(data)
        }
      } else {
        this.permissionSelectedAll = this.permissionSelectedAll.filter(item => item.key !== data.key)
        this.permissionSelectedShow = this.permissionSelectedShow.filter(item => item !== data.key)
      }
    },

    getSelectPermission() {
      let permissions = JSON.parse(JSON.stringify(this.permissionsAll))
      this.permissionSelectedShow.forEach((item) => {
        let key = item
        let departmentId = null
        let areaId = null

        if (item.includes("|")) {
          let arr = item.split("|")
          key = arr[0]
          if (arr[2] === "area") {
            areaId = parseInt(arr[1])
          } else if (arr[2] === "top") {
            departmentId = parseInt(arr[1])
          }
        }

        leve1: for (let i = 0; i < permissions.length; i++) {
          let itemLeve1 = permissions[i]
          for (let j = 0; j < itemLeve1.items.length; j++) {
            let itemLeve2 = itemLeve1.items[j]
            // Java 版 departmentId/areaId 为 null、Go 版序列化为 0，两侧归一后再比较
            if (itemLeve2.type === key && (departmentId || 0) === (itemLeve1.departmentId || 0) && (areaId || 0) === (itemLeve1.areaId || 0)) {
              itemLeve2.state = "VALID"
              break leve1
            }
          }
        }
      })
      return permissions
    },

    onPermissionSubmimt() {
      if (this.drawerForm.name === "") {
        this.$message.error("角色名称不能为空")
        return
      }

      if (this.permissionSelectedAll.length === 0) {
        this.$message.error("权限不能为空")
        return
      }

      let params = {
        name: this.drawerForm.name,
        permissions: this.getSelectPermission()
      }

      if (this.drawerForAdd) {
        addRole(params).then(({data}) => {
          if (data.code === 200) {
            this.$message.success(data.message)
            this.roleDrawerShow = false
            this.setupPageData()
          } else {
            this.$message.error(data.message)
          }
        }).catch(() => {
          this.$message.error(this.NETWORK_ERROR_MSG)
        })
      } else {
        params.id = this.tableSelectRow.id
        updateRole(params).then(({data}) => {
          if (data.code === 200) {
            this.$message.success(data.message)
            this.roleDrawerShow = false
            this.setupPageData()
          } else {
            this.$message.error(data.message)
          }
        }).catch(() => {
          this.$message.error(this.NETWORK_ERROR_MSG)
        })
      }
    },

  },

  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("EMPLOYEE_MANAGE_MODIFY")
        default:
          return false
      }
    }

  },

  filters: {
    timeFilter(value) {
      if (value === null || value.length < 19) {
        return value
      } else {
        return value.substring(0, 10) + " " + value.substring(11, 19)
      }
    },
  },

}
</script>


<style scoped lang="less">

.header {
  display: flex;
  justify-content: space-between;

  .left-content {
    margin-bottom: 20px;
  }

  .right {
    margin: 40px 20px 0px 0px; //上 右 下 左
  }
}

.edit-form {
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100%;

  .header-content {
    margin-bottom: 20px;
  }

  .main-content {
    flex: 1 0 auto;

    .el-form-item {
      display: flex;
      justify-content: flex-start;

      /deep/ .el-form-item__label {
        width: 100px;
      }

      /deep/ .el-input {
        width: calc(20vw);
      }
    }
  }

  .footer-content {
    text-align: center;
    flex: 0 0 auto;
  }
}

</style>
